import { SettingConst } from '../../types';

/**
 * Controls to enable/disable retailer seeing the most recently redesigned My Orders page
 */
export const MY_ORDERS_V4_241021 = 'MY_ORDERS_V4_241021' as SettingConst<
  'MY_ORDERS_V4_241021',
  boolean,
  | 'LOGGED_IN_RETAILER'
  | 'RETAILER_HEAD_TAGS'
  | 'RETAILER_ANDROID'
  | 'RETAILER_IOS'
>;
